export const CRMVI = {
    "crm":"CRM"
}